import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPercent, faHandHoldingDollar, faEye, faPen, faPlay, faStop, faTableList, faUser, faListCheck, faFileCirclePlus, faMagnifyingGlass, faBook, faFileCircleCheck, faTrashCan, faCertificate, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import styled, { css } from 'styled-components';
import { Select, Input, Button,StyledLinkLikeButton } from '../forms/shared_form_styles';
import { ScheduleLabel } from '../forms/shared_details_form_styles';
const ScheduleManagerDiv = styled.div`
 border:1px solid;
 padding:10px;
 width:auto;
 position:relative;
`;
const ScheduleManager = ({ schedule, setSchedule, timeFormAction, setTimeFormAction }) => {
  const [editingTime, setEditingTime] = useState(null);

  const addTime = (e) => {
    e.preventDefault();
    setTimeFormAction("add");
    setEditingTime({ day: "Monday", hour: "08:00" });
  };

  const editTime = (e) => {
    e.preventDefault();
    setEditingTime({});
    setTimeFormAction("edit");
  };

  const handleCloseTimeForm = (e) => {
    e.preventDefault();
    setEditingTime({});
    setTimeFormAction(null);
  };

  const handleAddTime = (e) => {
    e.preventDefault();
    setSchedule([...schedule, editingTime]);
    setTimeFormAction(null);
  };

  const handleRemoveSchedule = (e, indexToRemove) => {
    e.preventDefault();
    const updatedSchedule = schedule.filter((_, index) => index !== indexToRemove);
    setSchedule(updatedSchedule);
    setTimeFormAction(null);
  };

  const handleDayChange = (e) => {
    setEditingTime({ ...editingTime, day: e.target.value });
  };

  const handleHourChange = (e) => {
    setEditingTime({ ...editingTime, hour: e.target.value });
  };

  return (
    <ScheduleManagerDiv>
      {!timeFormAction && schedule.length === 0 && (
        <ScheduleLabel style={{ whiteSpace: 'nowrap', display: 'inline-block', padding:"5px"}}>
          <span style={{ display: 'inline-block', marginRight: '5px', fontWeight: 300 }}>
           Schedule for when it will be taught
          </span>
          {/* <StyledLinkLikeButton href="#" style={{ margin: "0 10px", display: "inline-block"}} onClick={addTime}>+</StyledLinkLikeButton> */}
          <StyledLinkLikeButton  style={{ display: "inline-block", position:"absolute", right:"10px", top:"5px"}}  href="#" onClick={addTime}><FontAwesomeIcon icon={faPlus} /></StyledLinkLikeButton>
        </ScheduleLabel>
      )}
      {!timeFormAction && schedule.length !== 0 && (
        <ScheduleLabel style={{ display: 'flex', gap: "5px" }}>
          <div style={{ whiteSpace: 'nowrap', display: 'flex', gap: "5px", justifyContent: "flex-start" }}>
            {schedule.length > 0 &&
              schedule.map((item, index) => (
                <span key={index} style={{ display: 'inline-block', marginRight: '5px' }}>
                  {item.day}, {item.hour}
                  {index < schedule.length - 1 ? ' - ' : ''}
                </span>
              ))}
          </div>
          <div style={{ padding: "4px", display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
            {/* <Button onClick={addTime}><FontAwesomeIcon icon={faPlus} /></Button>
            <Button onClick={editTime}><FontAwesomeIcon icon={faPen} /></Button> */}
                <StyledLinkLikeButton href="#" onClick={addTime}><FontAwesomeIcon icon={faPlus} /></StyledLinkLikeButton>
            <StyledLinkLikeButton href="#" onClick={editTime}><FontAwesomeIcon icon={faPen} /></StyledLinkLikeButton>
          </div>
        </ScheduleLabel>
      )}
      {timeFormAction === 'add' && (
        <div>
          <Select value={editingTime.day} onChange={handleDayChange}>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Domingo</option>
          </Select>
          <Input type="time" value={editingTime.hour} onChange={handleHourChange} />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px', padding: '10px' }}>
            <StyledLinkLikeButton href="#" onClick={handleAddTime}>Save</StyledLinkLikeButton>
            <StyledLinkLikeButton href="#" onClick={handleCloseTimeForm}>Cancel</StyledLinkLikeButton>
          </div>
        </div>
      )}
      {timeFormAction === 'edit' && (
        <div>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {schedule.map((item, index) => (
              <li key={index} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                {item.day}, {item.hour}
                <StyledLinkLikeButton href="#" onClick={(e) => handleRemoveSchedule(e, index)} style={{ marginLeft: '5px' }}>
                  <FontAwesomeIcon icon={faTrashCan} />
                </StyledLinkLikeButton>
              </li>
            ))}
          </ul>
          <StyledLinkLikeButton href="#" onClick={handleCloseTimeForm} style={{ marginTop: '10px' }}>Cancel</StyledLinkLikeButton>
        </div>
      )}
    </ScheduleManagerDiv>
  );
};

export default ScheduleManager;
